// components/EventsModal/EventsModal.jsx
import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const EventsModal = ({ show = false, onHide = () => {}, onContinue = () => {}, eventText = '' }) => {
  const translate = useSelector((state) => getTranslate(state.localize));

  if (!eventText) return null;

  return (
    <Modal show={show} onHide={onHide} style={{ zIndex: '10000000000' }} centered>
      <Modal.Header closeButton>
        <Modal.Title className='rtl'>اطلاعیه مهم</Modal.Title>
      </Modal.Header>

      <Modal.Body className='rtl'>
        <div style={{ marginBottom: '0.75rem' }}>
          <span className='ml-1 ticket'>
            <CKEditor
              disabled
              editor={ClassicEditor}
              data={eventText}
              config={{
                language: 'fa',
                toolbar: [],
              }}
            />
            <span style={{ padding: '.3rem' }}>آیا مایل به ادامه‌ی ثبت سفارش خود هستید؟</span>
          </span>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Row style={{ width: '100%', margin: '0' }}>
          <Col style={{ width: '50%', padding: '0' }}>
            <Button className='btn-success border-0 color-white rounded mt-2 mb-2 p-2' style={{ width: '100%' }} onClick={onContinue}>
              {translate('continue')}
            </Button>
          </Col>
          <Col style={{ width: '100%', padding: '0', margin: '0 0 0 4px' }}>
            <Button className='border-0 rounded mt-2 mb-2 p-2 btn-disable' style={{ width: '100%', backgroundColor: 'lightgrey' }} onClick={onHide}>
              {translate('dismiss')}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default EventsModal;
